import React from "react";
import SocialMediaIcon from "../about/SocialMediaIcon";

const AboutSection = () => {
  return (
      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="about"
      >
        <div className="w-100">
          <div>
            <h2 className="mb-0">
              Chanuth &nbsp;
              <span className="text-primary">Silva</span>
            </h2>
            <div className="">
              <i className="fas fa-map-marker-alt" />
              &nbsp;&nbsp; Ambalangoda · Sri Lanka <br />
              <i className="fas fa-mobile-alt" />
              &nbsp;&nbsp; +94 (0) 774185595 <br />
              <i className="fas fa-envelope" /> &nbsp;
              <a href="mailto:chanuth.silva2025@gmail.com">
                chanuth.silva2025@gmail.com
              </a>
            </div>
          </div>
          <br />
          <br />
          <br />
          <p className="lead mb-5">
          I am a results-driven Full Stack Software Engineer with over 3+ years of experience architecting and building scalable, high-performance web applications. 
          I specialize in developing cloud-native and microservices-based solutions using Java, Spring Boot, React, AWS, and Kafka. My expertise extends to crafting robust RESTful APIs, integrating real-time data pipelines, and connecting complex ERP systems.
          With a deep focus on performance optimization and clean, maintainable code, I thrive in agile environments where collaboration and innovation drive success. I also bring a solid understanding of DevOps practices, streamlining CI/CD pipelines to accelerate delivery and improve reliability.
          Whether it’s scaling backend services or building seamless user experiences, I deliver production-grade solutions that align with both business goals and modern engineering standards.
          </p>
          <div
            className="social-icons"
            data-aos="flip-left"
            data-aos-duration="500"
          >
            <SocialMediaIcon
              url="https://www.linkedin.com/in/chanuthsilva"
              icon="fab fa-linkedin-in"
            />
            <SocialMediaIcon
              url="https://github.com/Chanuth-silva10"
              icon="fab fa-github"
            />
            <SocialMediaIcon
              url="https://stackoverflow.com/users/17134706/kumara-maduka"
              icon="fab  fa-stack-overflow"
            /> 
            <SocialMediaIcon url="" icon="fab  fa-facebook" />
            <SocialMediaIcon url="" icon="fab fa-instagram" />
          </div>
          <br />
          <br />
          <a href="https://ieeexplore.ieee.org/document/10417592" target="blank" download>
            <button class="bounce btn btn-dark btn-lg text-primary m-2">Research</button>
          </a>
          {/* <a href="https://drive.google.com/drive/folders/1x2oRFpg25LeLMAMiv4Fo-ekahDY2nDeD" target="blank" download>
            <button class="bounce btn btn-dark btn-lg text-primary m-2">Cover Letter</button>
          </a> */}
          <a href="https://chanuth-silva-project-blog.onrender.com" target="blank" download>
            <button class="bounce btn btn-dark btn-lg text-primary m-2">My Blogger </button>
          </a>
        </div>
      </section>
    );
};

export default AboutSection;
